import React from 'react';
import { VoidFunctionType } from '../../../../core/types/coreTypes';
import { useAppDispatch } from '../../../../store/hooks';
import { resetUserPasswordThunk } from '../../../../store/thunks/settings/userViewPageThunks';
import ConfirmationModal from '../../../../core/components/confirmation-modal/ConfirmationModal';

type ResetUserPasswordModalProps = {
  isVisible: boolean,
  onCancel: VoidFunctionType,
  userName: string,
  userId?: number,
}

const ResetUserPasswordModal: React.FC<ResetUserPasswordModalProps> = ({
  isVisible, onCancel, userName, userId,
}) => {
  const dispatch = useAppDispatch();
  const confirmHandler = () => {
    userId && dispatch(resetUserPasswordThunk({
      id: +userId, userName, closeModal: () => onCancel(),
    }));
  };
  return (
    <ConfirmationModal
      customTitle="Reset password"
      isVisible={isVisible}
      onCancel={onCancel}
      confirmHandler={confirmHandler}
      customCreateLabel="Yes, reset"
      customText={<>
        You are about to reset password of
        {' '}
        <b>{userName}</b>
        .
      </>}
    />
  );
};

export default ResetUserPasswordModal;
